import { useEffect, useState } from 'react';

/** Touch-primary device (no hover-capable pointer). Distinct from useIsMobile,
 * which is viewport-WIDTH based (<=480px): this is device CAPABILITY. Use it to
 * gate hover-driven behavior that misfires on touch — e.g. on iOS/WebKit the
 * first tap on an element with a mouseenter/:hover reveal fires only the hover
 * (no click), so the real tap needs a second touch ("double-tap" bug). A
 * narrow desktop window is NOT touch, which is why the width hook is wrong here.
 */
const QUERY = '(hover: none) and (pointer: coarse)';

const useIsTouchDevice = () => {
  const [isTouch, setIsTouch] = useState(
    () => typeof window === 'object' && window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window !== 'object') {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(QUERY);
    const handleChange = (e) => setIsTouch(e.matches);

    /** addListener fallback for older Safari (< 14) */
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', handleChange);
    } else {
      mediaQueryList.addListener(handleChange);
    }

    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', handleChange);
      } else {
        mediaQueryList.removeListener(handleChange);
      }
    };
  }, []);

  return isTouch;
};

export default useIsTouchDevice;
